import { setComponentMapOverrides } from '@jutro/uiconfig';

import FNOLWC7Wizard from './FNOLWC7Wizard';
import WC7InjuryPage from './pages/Injury/InjuryPage';
import WC7WhatPage from './pages/What/WhatPage';
import WC7WherePage from './pages/Where/WherePage';

setComponentMapOverrides(
    {
        FNOLWC7Wizard: { component: 'FNOLWC7Wizard' },
        WC7WhatPage: { component: 'WC7WhatPage' },
        WC7InjuryPage: { component: 'WC7InjuryPage' },
        WC7WherePage: { component: 'WC7WherePage' }
    },
    {
        FNOLWC7Wizard,
        WC7WhatPage,
        WC7InjuryPage,
        WC7WherePage
    }
);

export {
    FNOLWC7Wizard as default
};
